import React from "react";

export default function DetailsCredential(props) {
  let credential = props.credential;

  return (
    <div className="details-card" style={{ backgroundImage: `url("html/img/card_no-icon_${credential.bg_color}.svg")` }}>
      <div className="container">
          <p className="item subtitle">{credential.credential_title}</p>
          <p className="item title">
              {credential.credential_title ===
              "MyNextID Email Credential (Self)" ? (
                <strong>{props.userEmail}</strong>
              ) : (
                <strong>{credential.credential_identifier}</strong>
              )}
            </p>
          <div className="item">
              <p>Issuer: {credential.issuer_title}</p>
              {/* <p className="item">Issuer: {credential.issuer_title}</p> */}

              {/* {credential.expires_in ? (
                <p>Expires: {credential.expires_in.split(" ")[0]}</p>
              ) : (
                credential.issued_at && (
                <p>Valid from: {credential.issued_at.split(" ")[0]}</p>
                )
              )} */}
              {credential.valid_from && <p>Valid from: {credential.valid_from.split("T")[0]}</p>}
              {!credential.valid_from && <p>Expires: {credential.expires_in.split("T")[0]}</p>}
            </div>
        </div>
    </div>
  );
}
